"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flipside = void 0;
const api_1 = require("./api");
const integrations_1 = require("./integrations");
const defaults_1 = require("./defaults");
class Flipside {
    constructor(apiKey, apiBaseUrl = defaults_1.DEFAULTS.apiBaseUrl) {
        // Setup API, which will be passed to integrations
        const api = new api_1.Api(apiBaseUrl, apiKey);
        // declare integrations on Flipside client
        this.query = new integrations_1.QueryIntegration(api);
    }
}
exports.Flipside = Flipside;
__exportStar(require("./types"), exports);
__exportStar(require("./errors"), exports);
//# sourceMappingURL=flipside.js.map